// libraries
import React, { useContext } from "react";
import { AnimatePresence, motion } from "framer-motion";

// styles
import styles from "./styles.module.scss";

// assets
import discoverMenu from "src/assets/images/home/discover_menu.svg";
import discover from "src/assets/images/home/discover_bg.svg";

// animation
import FadeRight from "src/components/Animation/FadeRight";

// context
import UserContext from "src/context/User";
import LocationPrompt from "../../old-Content/LocationPrompt";

const PopularBar = ({
  setShowSidebar,
  handleClick,
  showPrompt,
  isUpdating,
}) => {
  const { user, userLocation } = useContext(UserContext) || {
    user: null,
    userLocation: null,
  };

  const handleRequest = () => {
    alert("in progress");
  };

  return (
    <div className={styles.popular_bar}>
      <img src={discover} alt="discover" className={styles.bg} />
      <div className={styles.wrap}>
        <FadeRight duration={0.5}>
          <div className={styles.row}>
            <div>
              <h6>Discover</h6>
              <p>{userLocation?.city || user?.location?.city}</p>
            </div>
            {showPrompt && (
              <LocationPrompt
                user={user}
                userLocation={userLocation}
                handleClick={handleClick}
                handleRequest={handleRequest}
                className={styles.info}
              />
            )}
            <AnimatePresence>
              {isUpdating && (
                <motion.div
                  initial={{ x: 100 }}
                  animate={{ x: 0 }}
                  exit={{ x: 100, opacity: 0 }}
                  transition={{ type: "spring", stiffness: 100 }}
                  className={styles.placeholder}
                >
                  Updating location....
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        </FadeRight>

        <img
          onClick={() => setShowSidebar(true)}
          src={discoverMenu}
          alt="hamburger"
        />
      </div>
    </div>
  );
};

export default PopularBar;
